import { render, staticRenderFns } from "./BrokenDashboard.vue?vue&type=template&id=a0bafec2&scoped=true"
import script from "./BrokenDashboard.vue?vue&type=script&lang=js"
export * from "./BrokenDashboard.vue?vue&type=script&lang=js"
import style0 from "./BrokenDashboard.vue?vue&type=style&index=0&id=a0bafec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bafec2",
  null
  
)

export default component.exports